import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { analyticsTracker } from "@utils/analytics";
import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { BetSlipShare } from "@models";
import { BetSlipInteractionTypeEnum } from "@data-types/analytics-tracker/BetSlipInteractionTypeEnum";
import { SharedBetSlipActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";

export const SharedBetSlipPopupFooter = observer(
	function SharedBetSlipPopupFooter({ bet }: { bet: BetSlipShare }) {
		const { t } = useTranslation("mybets");

		const { quickPlayStore } = useRootAppStore();
		const { sharedBetSlipStore } = quickPlayStore;
		const rootStore = useRootAppStore();

		return (
			<div className="popup__footer">
				<div className="popup__footer__inner">
					<Button
						disabled={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData
						}
						isLoading={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData &&
							sharedBetSlipStore.showLoader ==
								ChangePageButton.PREVIOUS
						}
						isMostPlayed
						switchIcon
						iconLeft
						iconClassName="u-icon--tny u-icon--arrow-left"
						className={`popup--most__btn btn--med btn--primary--inverted`}
						type="button"
						onClick={() => {
							sharedBetSlipStore.changePage(
								ChangePageButton.PREVIOUS
							);
						}}
						btnText={t("COMMON.PREVIOUS_BUTTON")}
					/>
					<Button
						disabled={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData
						}
						isLoading={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData &&
							sharedBetSlipStore.showLoader ==
								ChangePageButton.NEXT
						}
						loaderClassName="btn--load--primary"
						switchIcon
						iconRight
						iconClassName="u-icon--tny u-icon--arrow-right"
						className={`popup--most__btn btn--med btn--primary--inverted`}
						type="button"
						onClick={() => {
							sharedBetSlipStore.changePage(
								ChangePageButton.NEXT
							);
						}}
						btnText={t("COMMON.NEXT_BUTTON")}
					/>
				</div>
				<Button
					disabled={
						sharedBetSlipStore.betSlipShareDetails.isFetchingData
					}
					className="btn btn--med btn--primary"
					type="button"
					iconClassName="u-icon u-icon--sml u-icon--refresh u-color--core--snow"
					onClick={() => {
						analyticsTracker.trackQuickPlayInteraction(
							SharedBetSlipActionsTypeEnum.TicketUse
						);
						analyticsTracker.trackBetSlipSharePopupAdd(
							BetSlipInteractionTypeEnum.ChatBetSlipShare
						);
						rootStore.betSlipStore.useBetSlip({
							...bet,
						});
						sharedBetSlipStore.deactivatePopup();
					}}
					btnText={t("SHARE.ADD_TO_SLIP")}
				/>
			</div>
		);
	}
);
